<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.group.account.title.detail")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.group.account.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.mailAddress")}}</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>{{ view.mailAddress }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.name")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.name }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.group")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.groupLarge.groupLargeName[$i18n.locale] }}<span class="mx-2">＞</span>{{ view.groupSmall.groupSmallName[$i18n.locale] }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.companyLabel[$i18n.locale] }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.companyName }}</mp-input-box>
        <mp-input-box>{{ view.companyNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ view.groupSmall.branchLabel[$i18n.locale] }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.branchName }}</mp-input-box>
        <mp-input-box>{{ view.branchNameKana }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.postNo")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.postNo }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.prefCd")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ $store.getters.prefNameByCode(view.prefCd)[$i18n.locale] }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.addr1")}}</mp-label>
      </v-col>
      <v-col cols="8" dense>
        <mp-input-box>{{ view.addr1 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.addr2")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr2 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.addr3")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.addr3 }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.busho")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.busho }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.telNo")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.telNo }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.remarks")}}</mp-label>
      </v-col>
      <v-col cols="8" class="pr-0">
        <mp-multiple-lines-input-box>{{ view.remarks }}</mp-multiple-lines-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.services")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <ul class="serviceList">
            <li v-for="s in view.services" :key="s.serviceId">
              {{ s.serviceName[$i18n.locale] }}
            </li>
          </ul>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.groupAdminFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
        <v-checkbox
          dense
          class="mt-0 pt-0"
          v-model="form.groupAdminFlg"
          :label="$t('message.group.account.ph.groupAdminFlg')"
          id="groupAdminFlg"
          :disabled="view.groupLarge.companyInsNoFlg === '1'"
        ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.group.account.label.detail.tempStopFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
        <v-checkbox
          dense
          class="mt-0 pt-0"
          v-model="form.tempStopFlg"
          :label="$t('message.group.account.ph.tempStopFlg')"
          id="tempStopFlg"
        ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        md="3"
        sm="6"
      >
        <mp-button wide @click="goList">{{$t("message.group.account.button.back")}}</mp-button>
      </v-col>
      <v-col
        class="text-center"
        md="3"
        sm="6"
      >
        <mp-button wide @click="goModify" >{{$t("message.group.account.button.modify")}}</mp-button>
        <mp-dialog modify :show="dialog.modifyComplete" @clickOk="goList" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.group.account.title.delete') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          {{ $t('message.group.account.desc.delete.text1') }}
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        md="4"
        sm="6"
      >
        <div>
          <mp-button red wide @click.stop="dialog.deleteConfirm = true">{{ $t('message.group.account.button.delete') }}</mp-button>
        </div>
        <mp-dialog delete confirm :show="dialog.deleteConfirm" @clickOk="goDelete" @clickCancel="dialog.deleteConfirm = false"/>
        <mp-dialog delete :show="dialog.deleteComplete" @clickOk="goList" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import GroupAccount from '@/api/group-account'
import MpError from '@/components/item/MpError.vue'
import { Common } from '@/api'
import StringUtils from '@/utils/StringUtil'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  name: 'top',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog,
    MpMultipleLinesInputBox
  },
  data: () => ({
    accountId: '',
    view: {
      errors: [],
      groupLarge: {
        groupLargeName: {
          ja: '',
          en: ''
        }
      },
      groupSmallList: [],
      groupSmall: {
        groupSmallName: {
          ja: '',
          en: ''
        },
        companyLabel: {
          ja: '',
          en: ''
        },
        branchLabel: {
          ja: '',
          en: ''
        }
      },
      mailAddress: '',
      name: '',
      groupLargeId: '',
      groupSmallId: '',
      companyId: '',
      companyName: '',
      companyNameKana: '',
      branchId: '',
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      prefName: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: []
    },
    form: {
      groupAdminFlg: null,
      tempStopFlg: null
    },
    dialog: {
      modifyComplete: false,
      deleteConfirm: false,
      deleteComplete: false
    }
  }),
  computed: {},
  methods: {
    goList () {
      this.$router.push({ path: '/group/account/list' })
    },
    goLogout () {
      this.$store.dispatch('logout')
        .then(this.$router.push({ path: '/auth/login' }))
    },
    async goModify () {
      await GroupAccount.update({
        accountId: this.accountId,
        groupSmallId: this.form.groupSmallId,
        groupAdminFlg: this.form.groupAdminFlg ? '1' : '0',
        tempStopFlg: this.form.tempStopFlg ? '1' : '0'
      })
        .then(() => {
          // 自身のアカウントを一時停止した場合は処理完了時に強制ログアウトする。
          if (this.accountId === this.$store.state.auth.userId) {
            this.goLogout()
          }
          this.dialog.modifyComplete = true
        })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    async goDelete () {
      // ダイアログ非表示
      this.dialog.deleteConfirm = false

      await GroupAccount.delete({ accountId: this.accountId })
        .then(() => {
          this.dialog.deleteComplete = true
          // 自身のアカウントを削除した場合は処理完了時に強制ログアウトする。
          if (this.accountId === this.$store.state.auth.userId) {
            this.goLogout()
          }
        })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.groupSmall.companyLabel.ja = StringUtils.isEmpty(this.view.groupSmall.companyLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.company.ja')
        : this.view.groupSmall.companyLabel.ja

      this.view.groupSmall.companyLabel.en = StringUtils.isEmpty(this.view.groupSmall.companyLabel.en)
        ? this.getDefaultLabelFromList(list, 'label.default.company.en')
        : this.view.groupSmall.companyLabel.en

      this.view.groupSmall.branchLabel.ja = StringUtils.isEmpty(this.view.groupSmall.branchLabel.ja)
        ? this.getDefaultLabelFromList(list, 'label.default.branch.ja')
        : this.view.groupSmall.branchLabel.ja

      this.view.groupSmall.branchLabel.en = StringUtils.isEmpty(this.view.groupSmall.branchLabel.en)
        ? this.getDefaultLabelFromList(list, 'label.default.branch.en')
        : this.view.groupSmall.branchLabel.en
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    }
  },
  created: async function () {
    // パラメータからアカウントIDを取得
    this.accountId = this.$route.params.id

    // アカウント情報取得
    const result = await GroupAccount.detail({ accountId: this.accountId })
      .catch(error => {
        this.view.errors = error.messages
      })
    this.view = { ...this.view, ...result }

    await this.setDefaultLabel()

    this.form = {
      groupAdminFlg: this.view.groupAdminFlg === '1',
      tempStopFlg: this.view.tempStopFlg === '1'
    }
  }
}
</script>

<style scoped>
.v-messages {
  min-height: 0px !important;
}
</style>
